/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInAccountMiniStatus = typeof LinkedInAccountMiniStatus[keyof typeof LinkedInAccountMiniStatus];


export const LinkedInAccountMiniStatus = {
  connecting: 'connecting',
  connected: 'connected',
  needs_reconnect: 'needs_reconnect',
  disconnected: 'disconnected',
} as const;
